var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProperty(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.5811 10.6621L13.3643 0.339122C12.8722 -0.114099 12.1295 -0.114099 11.6373 0.339122L0.420984 10.6621C0.0264528 11.0251 -0.10343 11.5843 0.0889528 12.0869C0.281824 12.5894 0.751062 12.9139 1.28427 12.9139H3.07577V23.2566C3.07577 23.6669 3.40487 23.9993 3.81112 23.9993H9.95907C10.3653 23.9993 10.6944 23.6669 10.6944 23.2566V16.9771H14.3077V23.2571C14.3077 23.6674 14.6368 23.9998 15.0431 23.9998H21.191C21.5973 23.9998 21.9264 23.6674 21.9264 23.2571V12.9139H23.7183C24.252 12.9139 24.7213 12.5894 24.9137 12.0869C25.106 11.5843 24.9757 11.0251 24.5811 10.6621Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProperty);
export default __webpack_public_path__ + "static/media/property.bc492a7e.svg";
export { ForwardRef as ReactComponent };